import { useEffect, useState } from "react";
import { GlobalTable } from "../../../global/components/GlobalTable";
import { useNavigate, useSearchParams } from "react-router-dom";
import useGet from "../../../global/hooks/useGet";
import { DeviceColumns } from "./Columns";
import { DeviceFilter } from "../Components/FilterComponent";
import CommonBreadcrumb from "../../../global/components/CommonBreadcrumb";
import { convertToUnix } from "../../../global/utils/unixToLocalTime";

const initialFilterState = {
  LogNo: "",
  LogTime: "",
  DeviceName: "",
  AccountName: "",
  Mac: "",
  Product: null,
  Model: "",
  Type: "",
  OemNo: "",
  DealerNo: "",
  CustomerNo: "",
  NodeType: null,
  SiteType: null,
  LicenseOption: "",
  LicenseDevice: "",
};

export const DeviceLog = () => {
  const [listData, setListData] = useState([]);
  const [params, setParams] = useSearchParams({
    limit: 10,
    sort_by: "LogNo",
    order: "desc",
  });
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {};

  const initialPagination = {
    current: parseInt(modParams.page) || 1,
    pageSize: parseInt(modParams.limit) || 10,
    total: 0,
  }; //

  const [pagination, setPagination] = useState(initialPagination);
  const [filter, setFilter] = useState(initialFilterState);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [filterNoValueText, setFilterNoValueText] = useState("");
  const [columnsValues, setColumnsValues] = useState([]);
  const [resetTrigger, setResetTrigger] = useState(false);

  const navigate = useNavigate();

  const breadcrumbItems = [
    {
      label: "Device Log",
      href: "/devicelog",
    },
  ];

  // to get table data from API server
  const query = new URLSearchParams(params);
  // Remove unwanted keys
  query.delete("pageSize");
  query.delete("total");
  query.delete("current");
  const updatedQuery = query.toString();

  const url = updatedQuery
    ? `${process.env.REACT_APP_API_URL}/api/devicelogs/?${updatedQuery}`
    : `${process.env.REACT_APP_API_URL}/api/devicelogs/`;
  const { data, loading, error, refetch } = useGet(url);

  useEffect(() => {
    const matchedFilter = {};
    for (const key in initialFilterState) {
      console.log({ key, modParams });
      if (modParams[key] !== undefined) {
        matchedFilter[key] = modParams[key];
      }
    }

    setFilter((prev) => ({
      ...prev,
      ...matchedFilter,
    }));
  }, []);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onRow = (record) => {
    return {
      onClick: (event) => {
        navigate(`/devicelog/info/${record?.LogNo}`);
      },
    };
  };

  const handleFilterChange = (e) => {
    const inputName = e.target.name;
    const inputValue = e.target.value.replace(/['""`''""]/g, "");
    setFilter({ ...filter, [inputName]: inputValue });
  };

  const handleFilter = (e) => {
    const filterDict = {};
    for (const key in filter) {
      if (
        filter[key] !== null &&
        filter[key] !== "" &&
        filter[key] !== undefined
      ) {
        if (key === "LogTime") {
          filterDict[key] = convertToUnix(filter[key]);
        } else {
          filterDict[key] = filter[key];
        }
        // filterDict[key] = filter[key];
      }
    }
    const isEmpty = JSON.stringify(filterDict) === "{}";

    if (isEmpty) {
      setFilterNoValueText("No value exists!");
      handleReset();
    } else {
      const params = {
        limit: 10,
        sort_by: "LogNo",
        order: "desc",
        ...filterDict,
      };
      setParams(params);
    }
  };

  // reset
  const handleReset = (e) => {
    // Reset the filter state to the initial state
    setFilter({
      current: 1,
      pageSize: 10,
      total: 0,
    }); //
    setPagination({
      current: 1,
      pageSize: 10,
      total: 0,
    }); //

    // Define the new parameters for the API call
    const params = {
      limit: 10,
      sort_by: "LogNo", // Make sure to specify sorting if necessary
      order: "desc",
    };

    // Update the parameters in the state
    setParams(params);
    setResetTrigger(!resetTrigger);
  };

  const paginationConfig = {
    current: pagination.current, //current page
    pageSize: pagination.pageSize, // items per page
    total: data?.count, // total items
    showSizeChanger: true,
    pageSizeOptions: [10, 20, 50, 100],
    showTotal: (total, range) => `Total ${total} items ${range[0]}-${range[1]}`,
    onChange: (page, pageSize) => {
      setPagination({
        ...pagination,
        current: page,
        pageSize: pageSize,
      });

      const updatedParams = {
        ...Object.fromEntries([...params.entries()]),
        limit: pageSize,
        page: page,
      };
      setParams(updatedParams);
    },
  };

  useEffect(() => {
    if (data && !loading) {
      const newData = data?.data?.map((el) => ({
        ...el,
        key: el?.LogNo,
      }));
      setListData(newData);
      setPagination({
        ...pagination,
        total: data?.totalCount || 0,
      });
    }
  }, [data, loading]);

  return (
    <div>
      <div className="pb-4 -mt-4 pt-[6px]">
        <CommonBreadcrumb breadcrumbItems={breadcrumbItems} />
      </div>
      <div className="p-4 bg-white rounded-[4px] border border-gray-200">
        <DeviceFilter
          filter={filter}
          handleFilterChange={handleFilterChange}
          handleFilter={handleFilter}
          handleReset={handleReset}
          selectedRowKeys={selectedRowKeys}
          setFilter={setFilter}
          params={params}
          data={data}
          setColumnsValues={setColumnsValues}
        />
        <GlobalTable
          columns={DeviceColumns(setParams, params, columnsValues)}
          dataSource={listData}
          // rowSelection={rowSelection}
          pagination={paginationConfig}
          onRow={onRow}
          loading={loading}
          resize
          resetTrigger={resetTrigger}
        />
      </div>
    </div>
  );
};
